import { render, staticRenderFns } from "./TransportTypeInput.vue?vue&type=template&id=9a3b8b36"
import script from "./TransportTypeInput.vue?vue&type=script&lang=js"
export * from "./TransportTypeInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports